import { render, staticRenderFns } from "./editProcessDialog.vue?vue&type=template&id=97d0f258&lang=pug"
import script from "./editProcessDialog.vue?vue&type=script&lang=js"
export * from "./editProcessDialog.vue?vue&type=script&lang=js"
import style0 from "./editProcessDialog.vue?vue&type=style&index=0&id=97d0f258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports